import merge from 'lodash/merge';
import parseClickUrl from './commonParsers/clickUrlParser';
import parseRebate from './commonParsers/rebateParser';
import { parseFlyout } from './categoriesParser';

const parseFeatured = (featured, state, action) =>
  merge(featured, {
    clickUrl: parseClickUrl(featured.clickUrl, state, action),
    merchant: featured.merchant
      ? {
        clickUrl: parseClickUrl(featured.merchant.clickUrl, state, action),
        rebate: parseRebate(featured.merchant.rebate, featured.merchant.tiers, state),
      }
      : null,
  });

export default (response, state, action) => (
  response.map(category =>
    merge(category, {
      featured: category.featured
        ? category.featured.map(featured => parseFeatured(featured, state, action))
        : null,
      flyout: category.flyout
        ? parseFlyout(category.flyout, state, action)
        : null,
    }))
);
